import { dateSort, projNumSort } from '../../utilities/services/sortConditionally'
import TrademarkApplicationsListItem from '../TrademarkApplicationsListItem/TrademarkApplicationsListItem'
import './TrademarkApplicationsList.css'

export default function TrademarkApplicationsList({user, trademarkApplications, updateTrademarkApplications, sortHeader, setSortHeader, sortOrder, setSortOrder, isMobile}) {
    const datesArray = ['priorityDate', 'filingDate', 'registrationDate', 'nationalEntryDate', 'nextActionDueDate']

    const handleTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
        setSortHeader(header);
        setSortOrder(newSortOrder);

        let sortedApplications = [...trademarkApplications];
        if (header === 'RPNumber') {
            sortedApplications = projNumSort(newSortOrder, header, sortedApplications);
        } else if (datesArray.includes(header)) {
            sortedApplications = dateSort(newSortOrder, header, sortedApplications);
        } else {
            sortedApplications.sort((a, b) => {
            if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            }
            });
        }
        updateTrademarkApplications(sortedApplications);
    }
  
    return (
    <div className='TrademarkApplicationsList'>
        { trademarkApplications && trademarkApplications.length > 0 ?
        <>
        <div className='trademarkApplicationsTable'>
          <table className=''>
            <thead>
                <tr>
                    <th id='RPNumber' onClick={handleTableHeaderClick} className='RPNumber'>
                        <div className='tableHeaderWithArrow'><div>RP Number&nbsp;&nbsp;</div>
                            { sortHeader==='RPNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='applicationNumber' onClick={handleTableHeaderClick} className='applicationNumber'>
                        <div className='tableHeaderWithArrow'><div>Application Number&nbsp;&nbsp;</div>
                            { sortHeader==='applicationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='applicationType' onClick={handleTableHeaderClick} className='applicationType'>
                        <div className='tableHeaderWithArrow'><div>Application Type&nbsp;&nbsp;</div>
                            { sortHeader==='applicationType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='trademarkType' onClick={handleTableHeaderClick} className='trademarkType'>
                        <div className='tableHeaderWithArrow'><div>Trademark Type&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='filingDate' onClick={handleTableHeaderClick} className='filingDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Filing Date&nbsp;&nbsp;</div>
                            { sortHeader==='filingDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='trademarkDescription' onClick={handleTableHeaderClick} className='trademarkDescription'>
                        <div className='tableHeaderWithArrow'><div>Trademark Description&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkDescription'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='applicationStatus' onClick={handleTableHeaderClick} className='applicationStatus'>
                        <div className='tableHeaderWithArrow'><div>Application Status&nbsp;&nbsp;</div>
                            { sortHeader==='applicationStatus'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='trademarkClasses' onClick={handleTableHeaderClick} className='trademarkClasses'>
                        <div className='tableHeaderWithArrow'><div>Trademark Classes&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkClasses'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='filing' onClick={handleTableHeaderClick} className='filing'>
                        <div className='tableHeaderWithArrow'><div>Filing&nbsp;&nbsp;</div>
                            { sortHeader==='filing'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='registrationNumber' onClick={handleTableHeaderClick} className='registrationNumber'>
                        <div className='tableHeaderWithArrow'><div>Registration Number&nbsp;&nbsp;</div>
                            { sortHeader==='registrationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='nextAction' onClick={handleTableHeaderClick} className='nextAction'>
                        <div className='tableHeaderWithArrow'><div>Next Action&nbsp;&nbsp;</div>
                            { sortHeader==='nextAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    <th id='nextActionDueDate' onClick={handleTableHeaderClick} className='nextActionDueDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Next Action Due&nbsp;&nbsp;</div>
                            { sortHeader==='nextActionDueDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                { trademarkApplications.length === 0 ?
                <tr>
                <td colSpan='12' className='noApplications text-center'>No Applications Found</td>
                </tr>
                :
                <>
                {trademarkApplications.map(application => (
                <TrademarkApplicationsListItem user={user} key={application._id} applicationItem={application} isMobile={isMobile} />
                ))}
                </>
                }
            </tbody>
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
        </>
        :
        <div className='emptyList'>
            <div className='text-center'>
                <h4 className='errorText pt-3'>No Trademark Applications</h4>
            </div>
        </div>
        }
    </div>
  )
}
